import { SyntheticEvent } from 'react'

// React re-dispatches a portal's events along the component tree, not the DOM.
export const isPortalOriginEvent = (event: SyntheticEvent): boolean => {
  const { currentTarget, target } = event
  if (!(currentTarget instanceof Node) || !(target instanceof Node)) {
    return false
  }
  return !currentTarget.contains(target)
}
